import { useState } from "react";

interface Props {
  onClick: () => void;
}

const ClearButton = ({ onClick }: Props) => {
  const [animate, setAnimate] = useState(false);

  const click = () => {
    onClick();
    setAnimate(true);
    setTimeout(() => {
      setAnimate(false);
    }, 1500);
  };

  return (
    <button
      onClick={click}
      className={`w-9 h-9 flex items-center justify-center px-2 bg-red-300 hover:bg-red-400 active:bg-red-500 text-black font-bold rounded transition-transform duration-300 ${animate ? "scale-110" : ""}`}
      aria-label="Copy slides to clipboard"
    >
      🗑️
    </button>
  );
};

export default ClearButton;
